import http from "../http-common";

class EnquestaService {

  getEnquesta(idEnquesta) {
    return http.get("/enquesta/"+idEnquesta,{});
  }
  listEnquestes(data) {
    return http.get("/enquesta/list",data);
  }
  listMetodesDistribucio() {
    return http.get("/enquesta/metodes-distribucio");
  }
  listVariables() {
    return http.get("/enquesta/variables");
  }
  listFiltreEnquestesDireccio() {
    return http.get("/enquesta/list-filtres-direccio");
  }
  saveEnquesta(form){
    let data = {};
    data.idEnquesta = form.idEnquesta    
    data.descripcio = form.descripcio;          
    data.questionari = {};
    data.questionari.idQuestionari = form.questionari;
    data.metodeDistribucio = {};
    data.metodeDistribucio.codi = form.metodeDistribucio;
    data.idAgrupacio = form.agrupacio;
    if(data.idEnquesta != null){
      return http.put("/enquesta",data);
    }else{
      return http.post("/enquesta",data);
    }
    
  }
  eliminarEnquesta(idEnquesta){
    return http.delete("/enquesta/"+idEnquesta);
  } 
  assignarEnquesta(activacio,idConfigPerfil,file,eliminarAssignacionsPrevies){
    let formData = new FormData();
    formData.append('file', file);
    formData.append('eliminarAssignacionsPrevies', eliminarAssignacionsPrevies);
    return http.post("/enquesta/"+activacio.idEnquesta+"/"+activacio.idActivacio+"/"+idConfigPerfil+"/assignar",formData,  {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    });    
  }
  activarEnquesta(activacio){
    let data = {};
    return http.post("/enquesta/"+activacio.idEnquesta+"/"+activacio.idActivacio+"/activar",data);    
  }
  saveQuotaEnquesta(data){
    return http.post("/enquesta/"+data.idEnquesta+"/quota",data);
  }
  eliminarQuotaEnquesta(idEnquesta,idQuota){
    return http.delete("/enquesta/"+idEnquesta+"/quota/"+idQuota);
  }
  saveActivacioEnquesta(data){
    if(data.idActivacio != null){
      return http.put("/enquesta/activacio/",data);
    }else{
      return http.post("/enquesta/activacio/",data);
    }
  }
  eliminarActivacioEnquesta(data){
    return http.delete("/enquesta/"+data.idEnquesta+"/activacio/"+data.idActivacio);
  }
  getActivacioEnquesta(idEnquesta,idActivacio) {
    return http.get("/enquesta/"+idEnquesta+"/activacio/"+idActivacio,{});
  }
  exportResultats(data){
    let url = '/resultats/export';

    return http.post(url,data,{
      headers: {
        Accept: 'application/octet-stream',
      },
      responseType: 'arraybuffer',
    });    
  }
  getResultats(data) {
    let url = "/resultats/";    
    return http.post(url,data);
  } 
  getResultatsDireccio(data) {
    let url = "/resultats/direccio";    
    return http.post(url,data);
  }
}

export default new EnquestaService();